import React, { useState, useEffect, useMemo } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { getDeals, deleteDeal } from "../../../api/deal";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button, Input, Row, Col } from "reactstrap";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

export default function DealList() {
    const navigate = useNavigate();

    const currentUser = useMemo(() => {
        return JSON.parse(localStorage.getItem("currentUser")) || {};
    }, []);

    const role = useMemo(() => currentUser.role || currentUser.roleName || {}, [currentUser]);

    const hasPermission = (action) => {
        if (role?.name === "super admin") return true;
        return (
            role?.permissions &&
            role.permissions.some(
                (perm) => perm.resource === "Sales" && perm.actions.includes(action)
            )
        );
    };

    const permissions = {
        create: hasPermission("create"),
        read: hasPermission("update") || hasPermission("delete"),
        update: hasPermission("update"),
        delete: hasPermission("delete"),
    };

    useEffect(() => {
        console.log("Current User:", currentUser);
        console.log("Role:", role.name);
        console.log("Permissions:", role.permissions);
        console.log("Permissions State:", permissions);
    }, [currentUser, role]);

    const {
        response,
        loading,
        error,
        setPage,
        page,
        setMeta,
        totalPages,
    } = usePagination(getDeals, null, true);

    const [filters, setFilters] = useState({
        budgetMin: "",
        budgetMax: "",
    });

    function handleFilter() {
        setMeta((m) => ({
            ...m,
            page: 1,
            payload: {
                ...filters,
            },
        }));
    }

    const handleDelete = async (id) => {
        if (window.confirm(t("Are you sure you want to delete this deal?"))) {
            try {
                await deleteDeal(id);
                setPage(1);
            } catch (error) {
                console.error("Delete failed:", error);
                alert(t("Failed to delete deal."));
            }
        }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs
                    title={t("Deals")}
                    addUrl={permissions.create ? "/deals/add/" : null}
                    hasAddBtn={permissions.create}
                    isMainPage={true}
                />

                {/* Filters (optional) */}
                {/* <Row className="mb-3">
                    <Col md={3}>
                        <Input
                            type="number"
                            placeholder={t("Min Budget")}
                            value={filters.budgetMin}
                            onChange={(e) =>
                                setFilters({ ...filters, budgetMin: e.target.value })
                            }
                            onKeyDown={(e) => e.key === "Enter" && handleFilter()}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            type="number"
                            placeholder={t("Max Budget")}
                            value={filters.budgetMax}
                            onChange={(e) =>
                                setFilters({ ...filters, budgetMax: e.target.value })
                            }
                            onKeyDown={(e) => e.key === "Enter" && handleFilter()}
                        />
                    </Col>
                    <Col md="auto">
                        <Button color="primary" onClick={handleFilter}>
                            {t("Filter")}
                        </Button>
                    </Col>
                </Row> */}

                {(permissions.read || permissions.update || permissions.delete) ? (
                    response && response.length > 0 && !loading ? (
                        <CustomTable
                            emptyMsg={t("No Deals Found.")}
                            data={response}
                            loading={loading}
                            error={error}
                            cols={[
                                {
                                    label: t("Lead"),
                                    key: "leadId",
                                    style: { width: "20%" },
                                    renderer: (row) => row.leadId?.name || t("No lead assigned"),
                                },
                                {
                                    label: t("Status"),
                                    key: "StatusDeal",
                                    style: { width: "15%" },
                                    renderer: (row) => row.StatusDeal?.name || t("No status assigned"),
                                },
                                {
                                    label: t("Budget"),
                                    key: "budget",
                                    style: { width: "20%" },
                                    renderer: (row) => `${row.budget?.toLocaleString() || 0} EGP`,
                                },
                                {
                                    label: t("Services"),
                                    key: "services",
                                    style: { width: "25%" },
                                    renderer: (row) =>
                                        Array.isArray(row.services) && row.services.length ? (
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: row.services
                                                        .map((s, index) => `${s.names}`)
                                                        .join("<br />"),
                                                }}
                                            />
                                        ) : (
                                            t("No services")
                                        ),
                                },
                                // {
                                //     label: t("Logs"),
                                //     key: "logs",
                                //     style: { width: "17%" },
                                //     renderer: (row) => (
                                //         <div className="d-flex gap-2">
                                //             {permissions.create && (
                                //                 <Button
                                //                     color="primary"
                                //                     size="sm"
                                //                     onClick={() => navigate(`/logs/${row._id}/`)}
                                //                 >
                                //                     {t("Create Log")}
                                //                 </Button>
                                //             )}
                                //             {permissions.read && (
                                //                 <Button
                                //                     color="secondary"
                                //                     size="sm"
                                //                     onClick={() => {
                                //                         localStorage.setItem("dealId", row._id);
                                //                         navigate(`/logs/get/${row._id}`);
                                //                     }}
                                //                 >
                                //                     {t("Show Logs")}
                                //                 </Button>
                                //             )}
                                //         </div>
                                //     ),
                                // },
                                // {
                                //     label: t("Feedbacks"),
                                //     key: "feedbacks",
                                //     style: { width: "20%" },
                                //     renderer: (row) => (
                                //         <div className="d-flex gap-2">
                                //             {permissions.create && (
                                //                 <Button
                                //                     color="primary"
                                //                     size="sm"
                                //                     onClick={() => navigate(`/feedback/add/${row._id}`)}
                                //                 >
                                //                     {t("Create Feedback")}
                                //                 </Button>
                                //             )}
                                //             {permissions.read && (
                                //                 <Button
                                //                     color="secondary"
                                //                     size="sm"
                                //                     onClick={() => {
                                //                         localStorage.setItem("dealIdfeedback", row._id);
                                //                         navigate(`/feedback/get/${row._id}`);
                                //                     }}
                                //                 >
                                //                     {t("Show Feedbacks")}
                                //                 </Button>
                                //             )}
                                //         </div>
                                //     ),
                                // },
                                // {
                                //     label: t("Deliverables"),
                                //     key: "deliverables",
                                //     style: { width: "23%" },
                                //     renderer: (row) => (
                                //         <div className="d-flex gap-2">
                                //             {permissions.create && (
                                //                 <Button
                                //                     color="primary"
                                //                     size="sm"
                                //                     onClick={() => navigate(`/deliverables/add/${row._id}`)}
                                //                 >
                                //                     {t("Create Deliverables")}
                                //                 </Button>
                                //             )}
                                //             {permissions.read && (
                                //                 <Button
                                //                     color="secondary"
                                //                     size="sm"
                                //                     onClick={() => {
                                //                         localStorage.setItem("dealIddealId", row._id);
                                //                         navigate(`/deliverables/get/${row._id}`);
                                //                     }}
                                //                 >
                                //                     {t("Show Deliverables")}
                                //                 </Button>
                                //             )}
                                //         </div>
                                //     ),
                                // },
                                {
                                    label: t("Actions"),
                                    key: "actions",
                                    style: { width: "20%" },
                                    renderer: (row) => (
                                        <div className="d-flex gap-2">
                                            {permissions.read && (
                                                <Button
                                                    color="secondary"
                                                    size="sm"
                                                    onClick={() => navigate(`/deals/show/${row._id}`)}
                                                >
                                                    {t("Show")}
                                                </Button>
                                            )}
                                            {permissions.update && (
                                                <Button
                                                    color="info"
                                                    size="sm"
                                                    onClick={() => navigate(`/deals/edit/${row._id}`)}
                                                >
                                                    {t("Edit")}
                                                </Button>
                                            )}
                                            {permissions.delete && (
                                                <Button
                                                    color="danger"
                                                    size="sm"
                                                    onClick={() => handleDelete(row._id)}
                                                >
                                                    {t("Delete")}
                                                </Button>
                                            )}
                                        </div>
                                    ),
                                }
                            ]}
                        />
                    ) : (
                        !loading && <div>{t("No results found.")}</div>
                    )
                ) : (
                    <div>{t("You do not have permission to view this list.")}</div>
                )}

                {response && !loading && permissions.read && (
                    <PaginationHandler page={page} setPage={setPage} totalPages={totalPages} />
                )}
            </div>
        </div>
    );
}
